import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page46() {
  useEffect(() => {
    document.title = "Маяк — Страница 45"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page44" />
        <ForwardLink href="/page46" />
      </div>

      <p style={{ textAlign: "right" }}>45.</p>
      <p>ночью. <i>Когда это произошло?</i></p>
      <p>
        Он смотрит вниз по лестнице: СТАРИК спит, растянувшись<br/>
        на ступеньках.
      </p>
      <p>МОЛОДОЙ подходит к своему ночному горшку: он полон мочи и дерьма.</p>
      <p>Он подходит к горшку старика: моча и дерьмо.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – ПОЗЖЕ ТЕМ ЖЕ УТРОМ</p>
      <p>
        МОЛОДОЙ, одетый в клеенчатый плащ, курит сигарету и несет<br/>
        полные мочи горшки. ВЕТЕР СРАЖАЕТСЯ С НИМ. Похмелье тоже.
      </p>
      <p>
        НАЧАЛСЯ ШТОРМ. СИЛЬНЫЙ. БЕЗЖАЛОСТНЫЙ. ОН ПОЧТИ<br/>
        СБИВАЕТ ЕГО С НОГ.
      </p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. СКАЛЫ – ПОЗЖЕ</p>
      <p>МОЛОДОЙ стоит над утесом.</p>
      <p>Он сбрасывает содержимое НОЧНЫХ ГОРШКОВ со скал...</p>
      <p>ВСЕ ВЫПЛЕСКИВАЕТСЯ ЕМУ В ЛИЦО.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Блять!
      </p>
      <p>Он роняет ночные горшки... они падают на камни.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        БЛЯТЬ!!
      </p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. ТРОПИНКА – ПОЗЖЕ ТЕМ ЖЕ УТРОМ</p>
      <p>МОЛОДОЙ таскает уголь, его лицо в дерьме. Идет дождь.</p>
      <br/>
      <p>ВНУТРИ. ЗДАНИЕ ФОГОРНА – ПОЗЖЕ ТЕМ ЖЕ УТРОМ</p>
      <p>МОЛОДОЙ разжигает огонь. Сирена включена.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – ПОЗЖЕ ТЕМ ЖЕ УТРОМ</p>
      <p>
        МОЛОДОЙ спотыкается о скользкие камни, толкая пустую<br/>
        тачку. Дождь мочится на него. Похмелье ударило<br/>
        ему в голову.
      </p>
      <p>ФОГОРН безжалостно ревет.</p>
      <p style={{ textAlign: "right" }}>45.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page44" />
        <ForwardLink href="/page46" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710315233/the-lighthouse-script/pg0woi54ysu62rosbxca.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page46;
